export default __webpack_public_path__ + "static/media/user.c2fc30b5.svg";